import { Dropdown } from '@statsbomb/kitbag-components';
import { useAtom, useAtomValue } from 'jotai';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { metricsAtom } from '@/atoms/metric';
import { radarTemplateCurrentMetricAtom, radarTemplateModalActiveStepAtom } from '@/atoms/radar';
import { useCurrentFormattedMinMaxMetricValues } from '@/hooks/useCurrentFormattedMinMaxMetricValues';
import { StringOption } from '@/types/generic';
import { getTranslationMetrics } from '@/utils/translations';

const MobileMetricDropdownBase = ({ options, isLoading }: { options: StringOption[]; isLoading?: boolean }) => {
  const { t } = useTranslation('modal');
  const [activeMetric, setActiveMetric] = useAtom(radarTemplateCurrentMetricAtom);
  const value = options.find(option => option.value === activeMetric);

  return (
    <Dropdown
      id="mobile-metric-dropdown"
      label={t('createRadarTemplateModal.step3.dropdownLabel')}
      labelPosition="none"
      variant="secondary"
      options={options}
      value={value}
      onChange={(option: StringOption) => setActiveMetric(option.value)}
      isLoading={isLoading}
    />
  );
};

const MobileMetricDropdownWidthData = () => {
  const { t } = useTranslation('metrics');
  const selectedMetrics = useAtomValue(metricsAtom);

  const getCurrentFormattedMinMaxMetricValues = useCurrentFormattedMinMaxMetricValues();

  const options = selectedMetrics.map(metric => {
    const metricName = t(`${getTranslationMetrics(metric)}.name`);
    const { min, max } = getCurrentFormattedMinMaxMetricValues(metric);
    const label = `${metricName} (${min} - ${max})`;

    return { label, value: metric };
  });

  return <MobileMetricDropdownBase options={options} />;
};

export const MobileMetricDropdown = () => {
  const activeStep = useAtomValue(radarTemplateModalActiveStepAtom);

  return (
    activeStep === 2 && (
      <div className="md:hidden p-4 bg-canvas-secondary-main relative z-[2]">
        <Suspense fallback={<MobileMetricDropdownBase options={[]} isLoading />}>
          <MobileMetricDropdownWidthData />
        </Suspense>
      </div>
    )
  );
};
